var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgFeedback = function SvgFeedback(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 18 18",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.342 2.409C13.645.855 11.392 0 9 0 6.608 0 4.356.855 2.66 2.409.944 3.978 0 6.069 0 8.297c0 1.737.568 3.384 1.648 4.787l-1.596 3.95a.703.703 0 00.935.906l4.523-1.994a9.586 9.586 0 003.49.648 9.62 9.62 0 004.338-1.026.703.703 0 00-.636-1.253A8.207 8.207 0 019 15.188a8.172 8.172 0 01-3.225-.652.703.703 0 00-.56.003l-3.21 1.416 1.102-2.728a.703.703 0 00-.117-.72c-1.036-1.215-1.583-2.67-1.583-4.21 0-3.8 3.406-6.89 7.593-6.89 4.188 0 7.594 3.09 7.594 6.89a6.408 6.408 0 01-1.174 3.681.703.703 0 101.153.805A7.807 7.807 0 0018 8.297c0-2.228-.944-4.32-2.658-5.888z"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFeedback, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/feedback.c46ae5cb.svg";
export { ForwardRef as ReactComponent };